import { render } from "./ReviewStateXTable.vue?vue&type=template&id=965b1956&ts=true"
import script from "./ReviewStateXTable.ts?vue&type=script&lang=ts&external"
export * from "./ReviewStateXTable.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__